import { render, staticRenderFns } from "./com-file.vue?vue&type=template&id=2d8c4fc1&scoped=true"
import script from "./com-file.vue?vue&type=script&lang=js"
export * from "./com-file.vue?vue&type=script&lang=js"
import style0 from "./com-file.vue?vue&type=style&index=0&id=2d8c4fc1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8c4fc1",
  null
  
)

export default component.exports